import { Component } from '../../../core/decorators';
import Template from './massia.form.tpl.html';
@Component({
	selector: 'massia-form',
	bindings: {
		label: '@',
		labelClass: '@',
		labelTitle: '@',
		labelTitlePos: '@',
		form: '<',
		id: '@',
		content: '@',
		iconClass: '@',
		iconTitle: '@',
		activeFormButton: '<', //afficher ou non les bouton de redirection vers le formulaire
		domainFormButton: '@', // nom du domain pour les boutons (gestion par massia authorize)
		editModeButton: '<', //afficher le bouton new ou edit (selon si le champ est renseigné ou pas)
		routeUpdateButton: '@', // route pour le bouton edit (exemple: "clients.edit({id: {{$ctrl.currDap.demandeur.id}}, genre: 'clients'})")
		routeCreateButton: '@', // route pour le bouton new (exemple: "clients.new({genre: 'clients'})")
		saveHistoryCallback: '&' // route pour sauvegarder l'objet (afin de garder les modifs lors de la creation)
	},
	transclude: true,
	template: Template
})
export class MassiaFormController {
	constructor() {}
	$onInit() {}
}

//exemple d'utilisation boutton de formulaire:
{
	/* <massia-form
	form="true"
	label="DAPS.DEMANDEUR"
	label-class="mandatory-field"
	active-form-button="true"
	edit-mode-button="!!$ctrl.currDap.demandeur"
	domain-form-button="dap"
	route-update-button="clients.edit({id: {{$ctrl.currDap.demandeur.id}}, genre: 'clients'})"
	route-create-button="clients.new({genre: 'clients'})"
></massia-form> */
}

// pour saveHistoryCallback, exemple pour la dap:
// saveDapHistoryRoute() {
// 	this.historyService.dap = this.currDap;
// }
